import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RechercheComponent } from '../recherche/recherche.component';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-custom-selection',
  templateUrl: './custom-selection.component.html',
  styleUrls: ['./custom-selection.component.scss'],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", display: "none" })
      ),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class CustomSelectionComponent implements OnInit {
  @ViewChild(RechercheComponent) rechercheComponent;

  constructor(private router: Router, public generalService: GeneralService) { }
  enregistrementTerminer = true;
  disabled = false
  selectedArticle
  associatedProducts: any[] = []
  staticImageUrl = 'assets/icon.png'
  imageCategorieSrc: any = 'assets/icon.png'
  imageCategorieName;
  lastFile = null;
  lastEvent = null;
  imageCategorieSrcAfterUpload;
  selections
  selectionSelected
  dataSourceSelections: any
  rowSelection: any
  allSelections
  parentVal
  ordreArticle
  showArticleList = false
  dataSourceArticleList
  selecedArticle
  dsSection: any
  allProducts = []
  promoProducts = []
  section = {
    ecSection_Code: null,
    ecSection_Icone: null,
    ecSection_Label: null,
    ecSection_Ordre: 0,
    ecSection_Statut: 1,
  };
  checkedStatus = []
  initSection() {
    this.section = {
      ecSection_Code: null,
      ecSection_Icone: null,
      ecSection_Label: null,
      ecSection_Ordre: 0,
      ecSection_Statut: 1,
    };
    this.rowSelection = null;
    this.lastFile = null;
    this.lastEvent = null;
    this.imageCategorieSrc = 'assets/icon.png';
    this.associatedProducts = []
  }

  async getAllSections() {
    await this.generalService.rechercheTable2("api_ecSection").subscribe((res: any) => {
      this.allSelections = res
      res.forEach((element, index) => {
        this.checkedStatus[index] = element.ecSection_Statut == 1;
      });
    })
  }


  ngOnInit(): void {
    this.getDsSection()
    this.getAllSections()
    this.getAllProducts()
    this.getAllPromoProducts()
  }

  ajouterSelection() {

    if (this.section.ecSection_Label != null && this.section.ecSection_Statut != 0) {
      this.enregistrementTerminer = false;
      this.generalService.getDS('ecSection').subscribe((res: any) => {
        const saveSection = (iconeName?) => {
          res.ecSection[0].ecSection_Label = this.section.ecSection_Label;
          res.ecSection[0].ecSection_Ordre = this.section.ecSection_Ordre;
          res.ecSection[0].ecSection_Statut = this.section.ecSection_Statut;
          res.ecSection[0].ecSection_Icone = iconeName || this.section.ecSection_Icone;
          const bodyToSend = {
            ApiForm: [res.ApiForm[0]],
            ecSection: [res.ecSection[0]]
          };
          this.generalService.enregisterTable(bodyToSend).subscribe(
            (section) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Section enregisté", true);
              this.getAllSections();
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(
                "Une erreur se produite",
                false
              );
            }
          );
        };

        if (this.lastFile) {
          this.generalService.uploadFile(this.lastFile, this.lastFile.name).subscribe(
            (data1: any) => {
              if (data1?.body?.fileName) {
                saveSection(data1.body.fileName);
              }
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Image non enregisté", false);
            }
          );
        } else {
          saveSection();
        }
      });
    } else {
      console.log(this.section);

      this.generalService.dialogSuccess(
        "Veuillez remplir les champs necessaire",
        false
      );
    }
  }

  modifierSelection() {
    if (!this.selectionSelected) {
      this.generalService.dialogSuccess(
        "Veuillez choisir une section",
        false
      );
      return;
    }

    this.enregistrementTerminer = false;

    const doSave = (iconeName?) => {
      this.selectionSelected.ecSection[0].ecSection_Label = this.section.ecSection_Label;
      this.selectionSelected.ecSection[0].ecSection_Ordre = this.section.ecSection_Ordre;
      this.selectionSelected.ecSection[0].ecSection_Statut = this.section.ecSection_Statut;
      if (iconeName) {
        this.selectionSelected.ecSection[0].ecSection_Icone = iconeName;
      }
      const bodyToSend = {
        ApiForm: [this.selectionSelected.ApiForm[0]],
        ecSection: [this.selectionSelected.ecSection[0]]
      };

      this.generalService.enregisterTable(bodyToSend).subscribe(async (res) => {
        await this.generalService.getDS('ecSection', this.selectionSelected.ecSection[0].ecSection_Code).subscribe((result: any) => {
          this.selectionSelected = result;
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess(
            "Modifié avec succés !",
            true
          );
          this.getAllSections();
          this.selectRowSelection(result.ecSection[0]);
        });
      });
    };

    if (this.lastFile) {
      this.generalService.uploadFile(this.lastFile, this.lastFile.name).subscribe(
        (data1: any) => {
          if (data1?.body?.fileName) {
            doSave(data1.body.fileName);
          }
        },
        (err) => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess("Image non enregisté", false);
        }
      );
    } else {
      doSave();
    }
  }
  deleteSelection() {
    if (!this.selectionSelected) {
      this.generalService.dialogSuccess(
        "Veuillez choisir une section",
        false
      );
      return;
    }
    this.generalService.supprimer(
      this.selectionSelected.ecSection[0].ecSection_Code,
      "ecSection"
    ).subscribe((res) => {
      this.generalService.dialogSuccess(
        "supprimé avec succés!",
        true
      );
      this.initSection()
      this.getAllSections()

    })
  }
  importer(id) {
    document.getElementById(id).click();
  }

  async getDsSection() {
    await this.generalService.getDS('ecSection').subscribe((res: any) => {
      console.log(res);


      this.dsSection = res[0].ecSection
    })
  }

  onChangeImagefile2(fileInput) {
    this.enregistrementTerminer = false;
    this.lastEvent = 'upload';
    var file = fileInput.target.files[0];
    this.lastFile = fileInput.target.files[0];
    var reader = new FileReader();
    console.log(file.type);
    if (file.type.toString().indexOf("image") == 0) {
      reader.onload = (e) => {
        this.enregistrementTerminer = true;
        this.imageCategorieSrc = reader.result;
        this.imageCategorieName = fileInput.target.files[0].name;
      };
      reader.readAsDataURL(file);
    } else {
      this.enregistrementTerminer = true;
      this.lastFile = null;
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image ",
        false
      );
    }
  }

  supprimerImage() {
    if (this.selectionSelected) {
      if (this.selectionSelected.ecSection[0].ecSection_Icone) {
        this.enregistrementTerminer = false;
        this.generalService.getDS('ecSection', this.selectionSelected.ecSection[0].ecSection_Code).subscribe((res: any) => {
          res.ecSection[0].ecSection_Icone = null;
          const bodyToSend = {
            ApiForm: [res.ApiForm[0]],
            ecSection: [res.ecSection[0]]
          };
          this.generalService.enregisterTable(bodyToSend).subscribe(
            (g) => {
              this.imageCategorieSrc = 'assets/icon.png';
              this.lastFile = null;
              this.lastEvent = null;
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(
                "Image supprimé avec succés",
                true
              );
              this.getAllSections();
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Image non supprimé", false);
            }
          );
        });
      } else {
        this.generalService.dialogSuccess(
          "Section ne contient pas d'image",
          false
        );
      }
    } else {
      // No section selected — just reset the local preview
      this.imageCategorieSrc = 'assets/icon.png';
      this.lastFile = null;
      this.lastEvent = null;
    }
  }
  selectRowSelection(element) {
    console.log(element);
    this.generalService.getDS('ecSection', element.ecSection_Code).subscribe((res: any) => {
      console.log(res);
      this.associatedProducts = []
      this.section = {
        ecSection_Code: res.ecSection[0].ecSection_Code,
        ecSection_Icone: res.ecSection[0].ecSection_Icone,
        ecSection_Label: res.ecSection[0].ecSection_Label,
        ecSection_Ordre: res.ecSection[0].ecSection_Ordre,
        ecSection_Statut: res.ecSection[0].ecSection_Statut,
      };
      this.imageCategorieSrc = res.ecSection[0].ecSection_Icone;
      this.lastFile = null;
      this.lastEvent = null;
      this.selectionSelected = res
      this.showArticleList = true
      res.ecSectionArt.forEach(element => {
        console.log(element);

        if (element.Art_Code != null) {
          const foundArt = this.findProduct(element.Art_Code)
          const artToDisplay = {
            ...element,
            label: foundArt.Art_Des ? foundArt.Art_Des : ""
          }
          console.log(artToDisplay);

          this.associatedProducts.push(artToDisplay)

          console.log(this.associatedProducts);

        }
      });
      this.associatedProducts.sort((a, b) => a.ecSectionArt_Ordre - b.ecSectionArt_Ordre);
      this.selectionSelected.ecSectionArt.sort((a, b) => a.ecSectionArt_Ordre - b.ecSectionArt_Ordre);
    })

  }

  onGroupeSelected(event) {
    this.selectionSelected = this.allSelections.find((cat) => {
      return cat.categorie_id == event.option.id;
    });
  }
  toggleSelectionImageDisplay(event, element) {

  }
  toggleSelectionDisplay(event, section) {
    console.log(section);


    this.generalService.getDS('ecSection', section.ecSection_Code).subscribe((res: any) => {
      section.ecSection_Statut == 0 ? (res.ecSection[0].ecSection_Statut = 1)
        : (res.ecSection[0].ecSection_Statut = 0);
      const bodyToSend = {
        ApiForm: [res.ApiForm[0]],
        ecSection: [res.ecSection[0]]
      }
      this.generalService.enregisterTable(bodyToSend).subscribe(
        (section) => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess("Section enregisté", true);
          // this.getMenu(true);
          this.getAllSections()
        },
        (err) => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess(
            "Une erreur se produite",
            false
          );
        }
      );
    })

  }
  onArticleSelected(row: any) {
    this.selectedArticle = row; // full object here
    console.log(row);

    this.parentVal = row.Art_Des; // keep this if you still need the display text bound somewhere
  }
  async ajouterArticle() {

    if (!this.selectionSelected || !this.selectedArticle) {
      this.generalService.dialogSuccess(
        "Veuillez choisir une section et un produit",
        false
      );
      return;
    }
    const productToAttach = {
      Art_Code: this.selectedArticle.Art_Code,
      U_timestamp: null,
      ecSectionArt_Code: null,
      ecSectionArt_Visibility: true,
      ecSection_Code: this.selectionSelected.ecSection[0].ecSection_Code,
      ecSectionArt_Ordre: this.ordreArticle,
    }
    const found = this.selectionSelected.ecSectionArt.find((item) => item.Art_Code === productToAttach.Art_Code)
    if (found) {
      this.generalService.dialogSuccess(
        "Article déja existant",
        false
      );
      return;
    }
    if (this.selectionSelected.ecSectionArt[0].Art_Code == null) {
      this.selectionSelected.ecSectionArt[0] = productToAttach
    } else {
      this.selectionSelected.ecSectionArt.push(productToAttach)
    }
    await this.generalService.enregisterTable(this.selectionSelected).subscribe(async (res) => {
      await this.generalService.getDS('ecSection', this.selectionSelected.ecSection[0].ecSection_Code).subscribe((result: any) => {
        this.selectionSelected = result;
        this.selectRowSelection(result.ecSection[0])
      })
    })

  }

  modifierArticle() { }

  supprimerArticleMenue() { }

  selectRowArticle(event, row, id) { }

  toggleRow(element, $event) { }

  modifierAssosiatedProduct(element, index: number) {
    this.selectionSelected.ecSectionArt[index].ecSectionArt_Ordre = element.ecSectionArt_Ordre
    this.selectionSelected.ecSectionArt[index].ecSectionArt_Visibility = element.ecSectionArt_Visibility

    this.generalService.enregisterTable(this.selectionSelected).subscribe(async (res) => {
      this.generalService.dialogSuccess(
        "Enregistré avec succée!",
        true
      );
      await this.generalService.getDS('ecSection', this.selectionSelected.ecSection[0].ecSection_Code).subscribe((result: any) => {
        this.selectionSelected = result;
        this.selectRowSelection(result.ecSection[0])
      })
    })
  }

  supprimerArticleFromSelection(index: number) {
    console.log(this.selectionSelected.ecSectionArt[index].ecSection_Code,
      "ecSectionArt");

    this.generalService.supprimer(
      this.selectionSelected.ecSectionArt[index].ecSection_Code,
      "ecSectionArt"
    ).subscribe((res) => {

      this.generalService.getDS('ecSection', this.selectionSelected.ecSection[0].ecSection_Code).subscribe((result: any) => {
        this.selectionSelected = result;
        this.selectRowSelection(result.ecSection[0])
      })

    })
  }

  findProduct(Art_Code: string) {
    const product = this.allProducts.find((item) => item.Art_Code === Art_Code);
    console.log(product);
    if (!product) {
      const promoProduct = this.promoProducts.find((item) => item.Art_Code === Art_Code);
      console.log(promoProduct);
      return promoProduct;
    }
    return product;
  }
  getAllProducts() {
    this.generalService.rechercheTable2('ecarticleauto2').subscribe((res: any) => {
      this.allProducts = res
    })
  }

  getAllPromoProducts() {
    this.generalService.rechercheTable2('ecArtPromo').subscribe((res: any) => {
      this.promoProducts = res
    })
  }

  toggleSelectionArtDisplay(index) {
    this.associatedProducts[index].ecSectionArt_Visibility = !this.associatedProducts[index].ecSectionArt_Visibility
    console.log(this.associatedProducts[index]);

  }
}